// Per-browser display preferences. Storage can be unavailable (private mode, blocked site data),
// so reads fall back to the default and writes are best-effort.

export const SIDEBAR_COLLAPSED_KEY = 'rls.sidebarCollapsed';

// Fired on window when a preference changes, so mounted components (e.g. the sidebar) can follow
export const PREFERENCE_EVENT = 'rls:preference';

export function readPreference<T>(key: string, fallback: T): T {
  try {
    const stored = localStorage.getItem(key);
    return stored === null ? fallback : (JSON.parse(stored) as T);
  } catch {
    return fallback;
  }
}

export function writePreference<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Not persisted; the preference still applies for this visit
  }
  window.dispatchEvent(new CustomEvent(PREFERENCE_EVENT, { detail: { key, value } }));
}
